import React from 'react';
import { Button } from 'antd';
import { useValueAddedPrice } from 'hooks/product-price/value-added-price';
import SPButton from "../../../carRental/base/SPButton";

interface IComponentProps {
  data?: any;
  permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = (props) => {
  const { data, permission } = props

  const { tableActionEdit, tableActionView, deleteItem, openModel } = useValueAddedPrice();


    // todo: hard code

  //从enums删除本身已有状态
  //const newEnums = enums?.filter((item: any) => item.key !== data.packageStatus) || []

  const onEdit = () => {
    tableActionEdit(data)
  };

  const onView = () => {
      tableActionView(data)
  };

  const onDelete = async () => {
      deleteItem(data)
  }

  const showModel = () => {
      openModel(data)
  }
  return (
    <>
          <SPButton permissionKey='value-added-price-view' permission={permission} type="link"  onClick={onView}>查看</SPButton>
          <SPButton permissionKey='value-added-price-edit' permission={permission} type="link"  onClick={onEdit}>编辑</SPButton>
          <SPButton permissionKey='value-added-price-delete' permission={permission} type="link"  onClick={onDelete}>删除</SPButton>
          <SPButton permissionKey='value-added-price-view-goods' permission={permission} type="link"  onClick={showModel}>查看应用商品</SPButton>
    </>
  );
};

export default SPTableActionBar;
